import { styled } from "@material-ui/core";
import Box from "@material-ui/core/Box";

export default styled(Box)(({ theme }: any) => ({
  padding: `${theme.spacing(4)}px ${theme.spacing(5)}px`,
  textAlign: "left",
}));
